<div class="change-password-container" [ngClass]="{ 'edit-mode': editMode }">
  @if (!editMode) {
    <div class="header-container">
      <div>
        <p>{{ 'changePassword.want_to_change_password' | translate }}</p>
        <p>{{ 'changePassword.for_security_reason' | translate }}</p>
      </div>

      <a role="button" tabindex="0" (click)="editMode = true" (keydown.enter)="editMode = true" (keydown.space)="editMode = true; $event.preventDefault()">{{ 'changePassword.edit_password' | translate }}</a>
    </div>
    @if (showSsoLink){
      <div class="header-container-MFA">
        <div>
          <p>{{ 'changePassword.authenticationText' | translate }}</p>
          <p>{{ 'changePassword.authenticationTextTwo' | translate }}</p>
        </div>

        <a role="button" tabindex="0" (click)="openLink()" (keydown.enter)="openLink()" (keydown.space)="openLink(); $event.preventDefault()">{{ 'changePassword.authenticationLink' | translate }}</a>
      </div>
    }
  } @else {
    <div class="header-container">
      {{ 'changePassword.error_password'| translate }}
    </div>
    <div class="input-container">
      <div>
      <ds-input-text
        [type]="'password'"
        [control]="formPassword.get('old_password')"
        [placeholder]="'changePassword.insert' | translate"
        [label]="'changePassword.old_password' | translate"
      ></ds-input-text>
      </div>
      <div>
        <ds-input-text
          [type]="'password'"
          [control]="formPassword.get('new_password')"
          [placeholder]="'changePassword.insert' | translate"
          [label]="'changePassword.new_password' | translate"
        ></ds-input-text>
      </div>
      <div>
        <ds-input-text
          [type]="'password'"
          [control]="formPassword.get('confirm_password')"
          [placeholder]="'changePassword.insert' | translate"
          [label]="'changePassword.confirm_password' | translate"
        ></ds-input-text>
      </div>
    </div>
    <div class="bar-container">
      <ds-button class="button-exit" [text]="'buttons.exit' | translate" [styleType]="'empty-main'" [width]="'small'" (click)="editMode = !editMode"></ds-button>
      <ds-button class="button-save" [text]="'buttons.save' | translate" [width]="'small'" (click)="onSave()" [isDisabled]="formPassword.invalid"></ds-button>
    </div>
  }
</div>
